export default "__VITE_ASSET__3eeacaee__"